import { ContactsQuery } from '../ContactsQuery.gql-types';

export const normalizeData = (data?: ContactsQuery) => {
  const totalContacts = data?.entityPageContactUsers?.total || 0;

  const contactUsers = data?.entityPageContactUsers?.collection || [];

  const userList = contactUsers.map((user) => ({
    label: user.label,
    ...user.xingId,
  }));

  const currentUser = data?.viewer?.xingId?.id;

  return {
    currentUser,
    userList,
    totalContacts,
  };
};
